import React from "react";
import { Link } from "react-router-dom";

export function BrandFormShell({
  badge,
  title,
  subtitle,
  children,
  footer,
  showLogo = false,
  centerHero = false,
  logoHref = "/",
}) {
  return (
    <div className="bg-white rounded-[2rem] shadow-[0_20px_60px_rgba(41,76,121,0.12)] border border-[#e8f2d1] overflow-hidden">
      <div
        className={`bg-gradient-to-r from-[#294c79] via-[#355b8f] to-[#294c79] text-white px-6 sm:px-10 py-8 sm:py-10 relative ${
          centerHero ? "text-center" : ""
        }`}
      >
        <div className="absolute inset-y-0 right-0 w-1/3 bg-[radial-gradient(circle_at_top_right,rgba(165,194,80,0.25),transparent_55%)]" />

        <div className={`relative z-10 ${centerHero ? "flex flex-col items-center" : ""}`}>
          {showLogo ? (
            <Link
              to={logoHref}
              className="mb-5 inline-flex items-center justify-center transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-white/20 rounded-[1.5rem]"
            >
              <div className="flex items-center justify-center rounded-[1.5rem] bg-white p-3 sm:p-4 shadow-[0_18px_40px_rgba(0,0,0,0.18)] border border-white/30">
                <img
                  src="/Logo.jpg"
                  alt="LiteRent"
                  className="h-20 w-auto sm:h-24 md:h-28 max-w-[220px] rounded-[1.2rem] object-contain block"
                />
              </div>
            </Link>
          ) : null}

          {badge ? (
            <div
              className={`inline-flex items-center rounded-full bg-white/10 border border-white/15 px-4 py-1.5 text-xs font-semibold tracking-wide uppercase mb-4 ${
                centerHero ? "justify-center" : ""
              }`}
            >
              {badge}
            </div>
          ) : null}

          <h1
            className={`text-3xl sm:text-4xl font-bold leading-tight ${
              centerHero ? "max-w-2xl mx-auto" : "max-w-2xl"
            }`}
          >
            {title}
          </h1>

          {subtitle ? (
            <p
              className={`mt-3 text-white/80 text-sm sm:text-base leading-relaxed ${
                centerHero ? "max-w-2xl mx-auto" : "max-w-2xl"
              }`}
            >
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>

      <div className="p-5 sm:p-8 lg:p-10">{children}</div>

      {footer ? (
        <div className="border-t border-[#edf2f7] bg-[#fbfcfe] px-5 sm:px-8 py-4 text-sm text-[#1a1a1a]/65">
          {footer}
        </div>
      ) : null}
    </div>
  );
}

export function FormStepper({ steps, currentStep }) {
  return (
    <div className="flex flex-wrap gap-3 mb-8">
      {steps.map((step, index) => {
        const active = currentStep === step.key;
        const done = steps.findIndex((s) => s.key === currentStep) > index;

        return (
          <div
            key={step.key}
            className={`flex items-center gap-3 rounded-full px-4 py-2 border text-sm transition ${
              active
                ? "bg-[#294c79] text-white border-[#294c79]"
                : done
                ? "bg-[#e8f2d1] text-[#294c79] border-[#d7e7b2]"
                : "bg-white text-[#294c79]/70 border-[#e5e7eb]"
            }`}
          >
            <span
              className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                active
                  ? "bg-white text-[#294c79]"
                  : done
                  ? "bg-[#294c79] text-white"
                  : "bg-[#f4f6f8] text-[#294c79]/70"
              }`}
            >
              {done ? "✓" : index + 1}
            </span>
            <span className="font-medium">{step.label}</span>
          </div>
        );
      })}
    </div>
  );
}

export function FormSection({ title, description, children }) {
  return (
    <section className="rounded-3xl border border-[#edf2f7] bg-[#fbfcfe] p-5 sm:p-6">
      <div className="mb-5">
        <h2 className="text-xl font-semibold text-[#294c79]">{title}</h2>
        {description ? (
          <p className="mt-1 text-sm text-[#1a1a1a]/65 leading-relaxed">
            {description}
          </p>
        ) : null}
      </div>
      {children}
    </section>
  );
}